import React from 'react';
import Styled from './styles';

export const SidebarSubTypeFilter = (props) => {
  const { selectedSubFilter, children, type, onSelect } = props;

  const handleClick = () => {
    onSelect(type);
  };

  return (
    <Styled.TypeFilterBtn onClick={handleClick} isActive={selectedSubFilter === type}>
      {children}
    </Styled.TypeFilterBtn>
  );
};
